import type { SiteCatalog } from './types';

export const site: SiteCatalog = {
	person: {
		name: 'Timo Prüße',
		givenName: 'Timo',
		familyName: 'Prüße',
		jobTitle: 'Software engineer',
		employer: { name: 'Mill', url: 'https://www.mill.com', location: 'San Bruno, CA' },
		home: 'Braunschweig, Germany',
		email: 'hi@timo-pruesse.de',
		siteUrl: 'https://www.timo-pruesse.de',
		tagline: 'I write software at Mill. When I can, I chase golden hour with a camera.',
		sameAs: [
			'https://github.com/timopruesse/',
			'https://www.instagram.com/timo.roams/',
			'https://twitter.com/TimoPruesse/'
		],
		portrait: {
			id: 'DcJs0ykjrks',
			alt: 'Timo Prüße at golden hour on a California coastline, warm light on his face',
			src: '/photos/portrait-DcJs0ykjrks.jpg',
			href: 'https://www.instagram.com/p/DcJs0ykjrks/',
			aspect: '4/5'
		}
	},
	meta: {
		title: 'Timo Prüße · software and photography',
		description:
			'I write software at Mill in San Bruno and live in Braunschweig. Photos at @timo.roams. I also built machine_setup.',
		ogImage: '/og-image.jpg'
	},
	instagram: {
		handle: '@timo.roams',
		url: 'https://www.instagram.com/timo.roams/'
	},
	missFrame: {
		id: 'DcJs0ykjrks-2',
		alt: 'Over-the-shoulder view toward hazy California hills under a low golden-hour sun',
		src: '/photos/miss-DcJs0ykjrks.jpg',
		href: 'https://www.instagram.com/p/DcJs0ykjrks/?img_index=2',
		aspect: '4/5'
	},
	tools: [
		{
			id: 'machine_setup',
			kind: 'run',
			name: 'machine_setup',
			blurb:
				'I wrote this CLI for the days after a wipe or a new laptop. Point it at a config and it installs packages, clones repos, and sets up the links you want.',
			githubUrl: 'https://github.com/timopruesse/machine_setup',
			installCommand:
				'curl -fsSL https://raw.githubusercontent.com/timopruesse/machine_setup/main/install/install.sh | sh'
		},
		{
			id: 'dotfiles',
			kind: 'reference',
			name: 'dotfiles',
			blurb: 'My shell, editor, and agent setup. Steal whatever is useful.',
			githubUrl: 'https://github.com/timopruesse/.dotfiles',
			teasers: ['nvim', 'zsh', 'ai agents', 'herdr', 'sync scripts']
		}
	],
	socials: [
		{ id: 'github', label: 'GitHub', href: 'https://github.com/timopruesse/' },
		{ id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/timo.roams/' },
		{ id: 'x', label: 'X', href: 'https://twitter.com/TimoPruesse/' },
		{ id: 'email', label: 'Email', href: 'mailto:hi@timo-pruesse.de' }
	],
	pages: [
		{ label: 'Kit', href: '/kit' },
		{ label: 'Golden hour', href: '/golden-hour' },
		{ label: 'Contact', href: '/contact' },
		{ label: 'Develop', href: '/develop' },
		{ label: 'machine_setup', href: '/develop/machine_setup' },
		{ label: 'dotfiles', href: '/develop/dotfiles' }
	],
	imprint: { label: 'Imprint', href: '/imprint' },
	contactSheet: [
		{
			id: 'DbgkXM7jl41',
			alt: 'Young roe deer buck standing in a harvested field at golden hour',
			src: '/photos/frame-4-DbgkXM7jl41.jpg',
			href: 'https://www.instagram.com/timo.roams/p/DbgkXM7jl41/',
			aspect: '4/5'
		},
		{
			id: 'DbMKQ9AOvTP',
			alt: 'Hot air balloon with red accents floating past a gibbous moon in a clear blue sky',
			src: '/photos/frame-1-DbMKQ9AOvTP.jpg',
			href: 'https://www.instagram.com/timo.roams/p/DbMKQ9AOvTP/',
			aspect: '4/5'
		},
		{
			id: 'DbQRPRmjkhE',
			alt: 'Red kite in flight against a clear blue sky, wings outstretched',
			src: '/photos/frame-2-DbQRPRmjkhE.jpg',
			href: 'https://www.instagram.com/timo.roams/p/DbQRPRmjkhE/',
			aspect: '1/1'
		},
		{
			id: 'DbVOPP_Oi63',
			alt: 'White swan on calm water in warm golden light, neck curved',
			src: '/photos/frame-3-DbVOPP_Oi63.jpg',
			href: 'https://www.instagram.com/timo.roams/p/DbVOPP_Oi63/',
			aspect: '1/1'
		}
	],
	routes: [
		{ path: '/', priority: '1.00' },
		{ path: '/kit', priority: '0.70' },
		{ path: '/golden-hour', priority: '0.70' },
		{ path: '/contact', priority: '0.70' },
		{ path: '/develop', priority: '0.70' },
		{ path: '/develop/machine_setup', priority: '0.70' },
		{ path: '/develop/dotfiles', priority: '0.70' }
	]
};
